import { inject } from "@angular/core";
import { Route, UrlSegment } from "@angular/router";
import { AuthService } from "./auth.service";
import { config } from "@core/interfaces/api_baseurl";
import { SharedService } from "@shared/shared.service";

export async function IsEncryption(route: Route, segments: UrlSegment[]): Promise<boolean> {

    const _SharedService: SharedService = inject(SharedService);
    const _AuthService: AuthService = inject(AuthService);
    const domainKey: string = _SharedService.domainKey;

    return await new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('niamod', domainKey);
        _AuthService.postdata(
            formData,
            config.auth.getEncryptionMode
        ).subscribe((res: any) => {
            if (res.data) {
                // localStorage.setItem('evulaVtpyrcne', res?.data?.encrypt)
                _AuthService.encryptioNsubjectValue(res.data.encrypt);
                return resolve(true);
            }
        });
    })


}